var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.sent
    ? _c(
        "form",
        {
          staticClass: "extras-form",
          attrs: { action: _vm.action, method: "POST" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-wrap align-items-start justify-content-center",
            },
            [
              _vm.serviceBreakdown.length
                ? _c("article", { staticClass: "desc-wrap" }, [
                    _c("h2", { staticClass: "desc__title" }, [
                      _vm._v("Description"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "desc__list" },
                      _vm._l(_vm.serviceBreakdown, function (service) {
                        return _c(
                          "li",
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              _vm._s(service[0]) + "\n                    "
                            ),
                            service[1]
                              ? [
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("em", [_vm._v(_vm._s(service[1]))]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.items.length > 0
                ? _c("div", { staticClass: "extras-wrap" }, [
                    _c(
                      "div",
                      {
                        staticClass: "extras",
                        class: { "has-error": _vm.$v.itemsSelected.$error },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._l(_vm.items, function (it, idx) {
                          return _c(
                            "div",
                            {
                              key: it.id,
                              staticClass: "extras__row",
                              class: { "has-qty": it.hasQty },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "extras__label",
                                  attrs: {
                                    role: "checkbox",
                                    "aria-checked": it.selected,
                                    tabindex: "0",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggle(it)
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.toggle(it)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.toggle(it)
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("button", {
                                    staticClass: "ring",
                                    class: { "is-on": it.selected },
                                    attrs: {
                                      type: "button",
                                      "aria-hidden": "true",
                                      tabindex: "-1",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(it.title) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: it.hasQty,
                                      expression: "it.hasQty",
                                    },
                                  ],
                                  staticClass: "qty",
                                  class: {
                                    "is-disabled":
                                      !it.selected ||
                                      !it.hasQty ||
                                      _vm.hasQtyError(it),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "qty__btn",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "decrease",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.dec(it)
                                        },
                                      },
                                    },
                                    [_vm._v("−")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.number",
                                        value: it.qty,
                                        expression: "it.qty",
                                        modifiers: { number: true },
                                      },
                                    ],
                                    staticClass: "qty__input",
                                    attrs: {
                                      type: "number",
                                      min: "0",
                                      max: it.limit || null,
                                      disabled: !it.selected || !it.hasQty,
                                    },
                                    domProps: { value: it.qty },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          it,
                                          "qty",
                                          _vm._n($event.target.value)
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "qty__btn",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "increase",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.inc(it)
                                        },
                                      },
                                    },
                                    [_vm._v("+")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "extras__price",
                                  class: {
                                    "is-inactive":
                                      !it.selected || _vm.hasQtyError(it),
                                  },
                                },
                                [_vm._v("+ " + _vm._s(_vm.fmt(it.price)))]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.$v.itemsSelected.$error
                      ? _c("div", { staticClass: "error-msg" }, [
                          _vm._v("Please select at least one extra."),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-center mt-5" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-modal",
                    rawName: "v-b-modal",
                    value: "modal-offers-terms",
                    expression: "'modal-offers-terms'",
                  },
                ],
                staticClass: "btn-offers-terms",
                attrs: { type: "button" },
              },
              [_vm._v("Additional Information & Terms")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "total-wrapper mt-4",
              attrs: { role: "status", "aria-live": "polite" },
            },
            [
              _c("span", { staticClass: "total-label" }, [_vm._v("TOTAL:")]),
              _vm._v(" "),
              _c("span", { staticClass: "total-value" }, [
                _vm._v(_vm._s(_vm.fmt(_vm.total))),
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "extras_total" },
                domProps: { value: _vm.total },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-offers-terms",
                size: "sm",
                "hide-header": "",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal-body-inner" }, [
                _c("div", { staticClass: "row py-11 px-11" }, [
                  _c("div", { staticClass: "col-16" }, [
                    _c("div", { staticClass: "text-terms" }, [
                      _c("p", { staticClass: "h3" }, [
                        _vm._v("Additional Information & Terms"),
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            "To confirm a booking a deposit of 30% is required."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Photos are delivered 4-5 months from the wedding day."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [_vm._v("Prices do not include 24% VAT.")]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "For destination weddings travel & accommodation expenses not included."
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-16 text-center mt-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-small",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$bvModal.hide("modal-offers-terms")
                          },
                        },
                      },
                      [_vm._v("OK")]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.sending
            ? _c("div", { staticClass: "page-overlay" }, [
                _c("span", { staticClass: "loader" }),
                _vm._v(" "),
                _c("p", { staticClass: "text-center" }, [
                  _vm._v("Finalizing your selection..."),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "response-wrapper response-wrapper-center mx-auto mb-2",
              staticStyle: { "max-width": "800px" },
            },
            [
              _vm.serverResponse.message
                ? _c(
                    "div",
                    {
                      staticClass: "response-msg",
                      class: _vm.serverResponse.class,
                    },
                    [
                      _c("p", { staticClass: "error-msg" }, [
                        _vm._v(_vm._s(_vm.serverResponse.message)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "cta mx-auto",
              attrs: { type: "submit", disabled: _vm.sending },
            },
            [
              !_vm.sending
                ? _c("span", [_vm._v("SUBMIT")])
                : _c("span", [_vm._v("SUBMITING…")]),
            ]
          ),
        ],
        1
      )
    : _c(
        "section",
        {
          ref: "success",
          staticClass: "extras-success",
          attrs: { role: "status", "aria-live": "polite", tabindex: "-1" },
        },
        [
          _c("img", {
            staticClass: "extras-success__icon",
            attrs: {
              src: "/public/site/nickyeconomou/dist/images/success.png",
              alt: "",
            },
          }),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("h3", { staticClass: "extras-success__title" }, [
            _vm._v(
              "A confirmation email with your selected options has been sent."
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-small mt-5",
              attrs: { href: "https://www.nickyeconomou.com/en" },
            },
            [_vm._v("DISCOVER MORE")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "extras-success__actions" }),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "extras__head" }, [
      _c("h3", [_vm._v("Additional Services")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "extras-success__title mt-5" }, [
      _c("b", [_vm._v("Thank you!")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }